import useSWRImmutable from 'swr/immutable'

type useStorefrontsProps = {
  uid: string
}

const fetcher = (url: string) => fetch(url).then((r) => r.json())

export default function useComercialRoutes({ uid }: useStorefrontsProps) {
  const { data, error, mutate, isLoading, isValidating } = useSWRImmutable(
    !uid ? null : `/api/routes/${uid}`,
    fetcher,
  )

  return {
    data: data,
    mutate,
    isLoading: isLoading,
    isValidating: isValidating,
    isError: error,
  }
}
